import IconButton from '@mui/material/IconButton'
import { CSSProperties, MouseEvent } from 'react'

import { colors, Icons } from 'variables'

interface Props {
  onClick: (e: MouseEvent) => void
  style?: CSSProperties
}

export default function SmallRemoveButtonComponent(props: Props) {
  return (
    <IconButton
      style={{
        ...unselectButtonStyle,
        ...props.style,
      }}
      onClick={props.onClick}
    >
      <Icons.closeButton style={unselectButtonIconStyle} />
    </IconButton>
  )
}

const unselectButtonStyle: CSSProperties = {
  backgroundColor: colors.PRIMARY_COLOR,
  color: 'white',
  height: 20,
  width: 20,
  borderRadius: '100%',
}

const unselectButtonIconStyle: CSSProperties = {
  fontSize: '14px',
}
